import { ReactElement } from 'react';

import {
  Calendar,
  ChakraBox,
  ChakraFlex,
  DateFormat,
  EquipUIFireflyV2Theme,
  Group,
  Text,
} from '@equip.health/ui';

import { AppointmentTimeIcon } from '~/lib/constants/appointment.constants';
import { formatDateWithTimezone } from '~/lib/util/calendar.util';

const {
  tertiary: {
    marigold: {
      base: brandTertiaryMarigoldBase,
      background: brandTertiaryMarigoldBg,
    },
  },
  primary,
} = EquipUIFireflyV2Theme.colors;

const TOP_LEVEL_ID = 'scheduler__review__appointment-time';

const AppointmentTime = ({
  appointmentTimeIcon = AppointmentTimeIcon.CALENDAR,
  color,
  end,
  start,
  timezoneCode,
  timezoneValue,
}: AppointmentDetailTime) => {
  const backgroundColor =
    color ??
    (appointmentTimeIcon === AppointmentTimeIcon.CALENDAR
      ? 'brand'
      : 'marigold');

  const iconProps = {
    fill:
      backgroundColor === 'marigold' ? brandTertiaryMarigoldBase : primary[100],
    fillOpacity: 1,
    height: '16px',
    width: '16px',
  };

  const AppointmentTimeIconMapper: Record<AppointmentTimeIcon, ReactElement> = {
    [AppointmentTimeIcon.CALENDAR]: <Calendar {...iconProps} />,
    [AppointmentTimeIcon.GROUP]: <Group {...iconProps} />,
  };

  const getStartDate = (date: string): string =>
    formatDateWithTimezone(
      date,
      `${DateFormat.weekdayShortMonthDateNoSpecialChar}`,
      timezoneValue,
    );

  const getTime = (date: string): string =>
    formatDateWithTimezone(date, 'h:mma', timezoneValue, true);

  return (
    <ChakraFlex align="center">
      <ChakraBox
        backgroundColor={
          backgroundColor === 'brand' ? brandTertiaryMarigoldBg : primary[10]
        }
        borderRadius="500px"
        padding="9px"
      >
        {AppointmentTimeIconMapper[appointmentTimeIcon]}
      </ChakraBox>
      <ChakraFlex
        direction="column"
        id={`${TOP_LEVEL_ID}__appointment-start-time`}
        paddingLeft="18px"
      >
        <Text
          color="neutral.primary"
          marginBottom="2px"
          variant="captionMedium"
        >
          {getStartDate(start)}
        </Text>
        <Text color="neutral.secondary" variant="caption">
          {`${getTime(start)} - ${getTime(end)} ${timezoneCode ?? ''}`}
        </Text>
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default AppointmentTime;
